import styled from "styled-components";

// ขยาย 238px / ย่อ 72px (เหลือแต่ไอคอน) เปลี่ยนด้วย class "collapsed"
export const SidebarWidgetStyled = styled.div`
  position: relative;
  z-index: 10;
  min-height: 100%;
  width: 238px;
  background: ${({ theme }) => theme.COLORS.BLUE_5};
  transition: width 0.25s ease;
  .s_logo_sec {
    padding: 1rem;
    text-align: center;
    overflow: hidden;
    .sidebar_logo {
      width: 200px;
      max-width: 100%;
      height: auto;
      transition: width 0.25s ease;
    }
  }
  .s_toggle_btn {
    position: absolute;
    top: 1.25rem;
    right: -0.875rem;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    border: 0.0625rem solid ${({ theme }) => theme.COLORS.GRAY_4};
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    color: ${({ theme }) => theme.COLORS.BLUE_2};
    box-shadow: 0 0.125rem 0.5rem rgb(8 21 66 / 12%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
    z-index: 5;
    &:hover {
      background: ${({ theme }) => theme.COLORS.GRAY_4};
    }
  }
  .s_menu_sec {
    margin: 0px;
    padding: 0px;
    list-style: none;
    .s_menu_item {
      padding: 1rem 1.5rem;
      display: flex;
      align-items: center;
      column-gap: 0.75rem;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      transition: all 0.3s ease;
      .s_menu_icon {
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }
      .s_menu_label {
        overflow: hidden;
        text-overflow: ellipsis;
        transition: opacity 0.2s ease;
      }
      &:hover {
        background: ${({ theme }) => theme.COLORS.GRAY_7};
      }
      &.active {
        color: ${({ theme }) => theme.COLORS.BLUE_4};
      }
    }
  }

  &.collapsed {
    width: 72px;
    .s_logo_sec {
      padding: 1rem 0;
      .sidebar_logo {
        /* รูปโลโก้มีทั้งไอคอน + คำว่า MiSUMi ตอนย่อให้เห็นแค่ไอคอน (ส่วนซ้ายของรูป) */
        width: 44px;
        height: 44px;
        object-fit: cover;
        object-position: left center;
      }
    }
    .s_menu_sec .s_menu_item {
      position: relative;
      padding: 1rem 0;
      justify-content: center;
      column-gap: 0;
      overflow: visible;
      /* ชื่อเมนูกลายเป็น tooltip ลอยทางขวา โผล่ตอน hover */
      .s_menu_label {
        position: absolute;
        left: calc(100% + 0.5rem);
        top: 50%;
        transform: translateY(-50%);
        padding: 0.375rem 0.75rem;
        border-radius: 0.5rem;
        background: ${({ theme }) => theme.COLORS.BLUE_7};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        box-shadow: 0 0.25rem 0.75rem rgb(8 21 66 / 18%);
        opacity: 0;
        pointer-events: none;
        white-space: nowrap;
        z-index: 20;
        &::before {
          content: '';
          position: absolute;
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
          border: 0.375rem solid transparent;
          border-right-color: ${({ theme }) => theme.COLORS.BLUE_7};
        }
      }
      &:hover .s_menu_label {
        opacity: 1;
      }
    }
  }
`;
